import $ from "jquery";

import GeneralKenticoForm from './form-general-kentico';

class GeneralInquiryForm extends GeneralKenticoForm
{
    /**
     * Load the reasonForContactDropdown with it's dropdown options.
     */
    #loadReasonForContactDropdown() {
        let select2Options = [{id: '', text: 'Select an Option'}];
        let options = Object.values( this.config.reasonForContactByLabel );
        options.forEach((option) => {
            select2Options.push(
                { id: option.Label, text: option.Label }
            );
        });
        this.reasonForContactDropdown.select2({ data: select2Options });
        window.initCustomDropdowns(this.reasonForContactDropdown, true);
    }

    /**
     * Add post data specific to this form to the given postData. This method is called
     * prior to posting the data.
     * @param {object} postData - post data object to add post data to 
     */
    addPostData(postData) {
        let reasonForContact = this.reasonForContactDropdown.val();
        // Add email address mapped to the selected reasonForContactDropdown.
        postData['IWantHelpWithEmail'] = this.config.reasonForContactByLabel[reasonForContact].Email;
        return postData;
    }

    /**
     * 
     * @param {object} config - {
     *      submitConfirmationContainer: JQuery selector syntax for the confirmation message
     *      form: JQuery selector for the lead form
     *      isPreviewEnabled: bool true if viewing the page in the cms admin pagebuilder
     * 
     *      postUrlPath: URL path to post the lead to.
     *      formId: Unique identifier for this form instance.
     *      reasonForContactDropdown: JQuery selector selector syntax for the inquiry options.
     * }
     */
    constructor(config) {
        super(config);
        super.getPostDataCallback = this.addPostData;

        this.config = config;
        this.reasonForContactDropdown = $(this.config.reasonForContactDropdown);
        this.#loadReasonForContactDropdown();
    }
}

export { GeneralInquiryForm as default }
